<template>
    <div class="basis">
        <img :src="li.BackUrl" v-if="li.BackUrl" alt="" ref="listimg">
        <div class="basis_content">
            <div class="basis_title">{{li.Title}}</div>
            <div class="basis_desc">{{li.SubTitle}}</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return{
          li:null,
        }
    },
    props:['list'],
    watch:{
      list:{
        handler(newName, oldName) {
          this.li=newName

        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
.basis{
    height: 100%;
}
 img{
             width: 100%;
             min-height: 100%;
             display: block;
             border-radius: 0.375rem;
             z-index: 0;
        }
        .basis_content{
            position: absolute;
            left: 0;
            top: 50%;
             transform: translateY(-50%);
             padding:0 3rem;
             text-align: left;
             .basis_title{
                font-size: 1.125rem;
                 color: #FFFFFF;
                 line-height: 1.5rem;
                 font-weight: 500;
                        
             }
            .basis_desc{
                font-size: 0.8125rem;
                color: #FFFFFF;
                line-height: 1.2rem;
            }
        }
</style>




// WEBPACK FOOTER //
// src/components/basis.vue